import * as z from 'zod';

// Validation schema for create user form
export const createAdminUserSchema = z.object({
  name: z.string().min(1, 'Full Name is required'),
  email: z.string().email('Invalid email address').optional().or(z.literal('')),
  phone_number: z.string().min(1, 'Phone Number is required'),
  role: z.enum(
    [
      'super_admin',
      'organization_manager',
      'venue_manager',
      'venue_operator',
      'viewer',
    ],
    {
      required_error: 'Please select a role',
    }
  ),
  organization_id: z.string().optional(),
  is_active: z.boolean(),
});

export type CreateUserFormValues = z.infer<typeof createAdminUserSchema>;

// Schema for edit user form
export const editAdminUserSchema = z.object({
  name: z.string().min(1, 'Full Name is required'),
  email: z.string().email('Invalid email address'),
  phone: z.string().min(1, 'Phone Number is required'),
  role: z.enum(
    [
      'super_admin',
      'organization_manager',
      'venue_manager',
      'venue_operator',
      'viewer',
    ],
    {
      required_error: 'Please select a role',
    }
  ),
  organization_id: z.number().nullable(),
  is_active: z.boolean(),
});

export type EditUserFormValues = z.infer<typeof editAdminUserSchema>;